<!-- About Us Section -->
<section class="py-5 bg-light">
  <div class="container">
    <h2 class="text-center text-primary fw-bold mb-4">About Us</h2>
    <p class="text-center mb-5 lead">
      <strong>HMC IT NETWORK SERVICES</strong> is a leading IT company based in <span class="text-primary">Dubai, UAE</span>.
      We specialize in providing <span class="text-success">cost-effective</span> products and solutions that empower organizations to grow and thrive.
      As an <span class="text-danger">authorized channel partner</span> for various industry-leading products, we cater to multiple industry verticals.
    </p>

    <p class="text-center mb-5 lead">
      From <span class="text-info">basic setups</span> to delivering <span class="text-warning">complex IT solutions</span>, our expert engineers analyze your technical requirements
      and propose <span class="text-success">durable and reliable</span> solutions within your timeframe. We work <strong>dedicatedly</strong> with our clients to build strong, lasting relationships.
    </p>

    <p class="text-center mb-5 lead">
      Companies of every size rely on us to manage their IT resourcing and infrastructure needs.
      <strong>We are here to serve you.</strong>
    </p>

    <p class="text-center mb-5 lead">
      Our <span class="text-primary">Systems Integration</span> team, with its vast expertise, is committed to exceeding client expectations
      on every project—no matter how big or small.
      Through <span class="text-danger">strategic partnerships</span> with renowned brands, we have become the <strong>preferred IT solutions vendor</strong> for many of our clients.
    </p>

    <!-- Key Values Section -->
    <div class="row text-center">
      <div class="col-lg-4 col-md-6 mb-4">
        <div class="card shadow-sm p-4 h-100">
          <h4 class="text-dark mb-3">Expert Team</h4>
          <p class="text-muted">Our team consists of skilled professionals dedicated to providing the best service possible.</p>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-4">
        <div class="card shadow-sm p-4 h-100">
          <h4 class="text-dark mb-3">Innovative Solutions</h4>
          <p class="text-muted">We offer creative and innovative solutions to optimize your business operations.</p>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-4">
        <div class="card shadow-sm p-4 h-100">
          <h4 class="text-dark mb-3">Client Satisfaction</h4>
          <p class="text-muted">We prioritize customer satisfaction and strive to exceed expectations with every project.</p>
        </div>
      </div>
    </div>
  </div>
</section>
